import { lazy, Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useAtom } from 'jotai';

import { useEvent } from '@bizzabo/entities';
import { instanaReportError } from '@bizzabo/instana-api';

import { showVideoAtom, createVideoAtom } from './atoms';
import ErrorPage from './components/ErrorPage';
import useTypeTracking from '../analytics';

const VideoPlayer = lazy(() => import('./components/VideoPlayer'));

type Props = {
    eventUniqueName: string;
};

const Video: React.FC<Props> = ({ eventUniqueName }) => {
    const { data: event } = useEvent(eventUniqueName);
    const [showVideo, setShowVideo] = useAtom(showVideoAtom);
    const { Track, trackClickEvent } = useTypeTracking({
        data: {
            category: 'VIDEO_MEETING',
        },
    });

    if (!showVideo) {
        return null;
    }

    const onError = (error: Error, info: { componentStack: string }) => {
        instanaReportError(error, { componentStack: info.componentStack });
    };

    const onReset = () => {
        setShowVideo(false);
        trackClickEvent({
            subCategory: 'ERROR_CLOSED',
        });
    };

    return (
        <Suspense fallback={null}>
            <Track>
                <ErrorBoundary FallbackComponent={ErrorPage} onError={onError} onReset={onReset}>
                    <VideoPlayer eventId={event.id} />
                </ErrorBoundary>
            </Track>
        </Suspense>
    );
};

export default Video;
export { createVideoAtom };
